module.exports = __webpack_public_path__ + "static/media/TW-puzzle-sudoku-min.cdc5c555.jpg";